import { useSelector } from "react-redux";
import { Input, Row } from "antd";
import type { ChangeEvent } from "react";
import { Settings, User } from "@version2/domain-package";
import type { FieldData, UserDocSelector, UserDocState } from "./types";
import { defaultUserDocSelector } from "./types";

type CurrentUserFieldProps = {
	userDocSelector?: UserDocSelector;
	data?: FieldData;
	settings: Settings;
	onSettingsChange: (settings: Settings) => void;
};

const CurrentUserField = ({
	userDocSelector,
	settings,
	onSettingsChange,
}: CurrentUserFieldProps) => {
	const selector = userDocSelector ?? defaultUserDocSelector;
	const userDoc = useSelector<UserDocState, User | null>(selector);

	const onChangedNameOrEmail = (name?: string, email?: string) => {
		const value = {
			name: name || settings?.value?.name,
			email: email || settings?.value?.email,
		};
		onSettingsChange(settings.copyWith({ editedValue: value }));
	};

	if (!userDoc) {
		return (
			<Row style={{ display: "flex", justifyContent: "space-between" }}>
				<Input
					style={{ width: "48%" }}
					placeholder="Name"
					value={settings?.value}
					onChange={(e: ChangeEvent<HTMLInputElement>) => onChangedNameOrEmail(e.target.value, undefined)}
				/>
				<Input
					style={{ width: "48%" }}
					placeholder="Email"
					value={settings?.value}
					autoComplete="email"
					onChange={(e: ChangeEvent<HTMLInputElement>) => onChangedNameOrEmail(undefined, e.target.value)}
				/>
			</Row>
		);
	}

	return (
		<Row style={{ display: "flex", justifyContent: "space-between" }}>
			<Input
				style={{ width: "48%" }}
				placeholder="Name"
				value={userDoc._.username}
				disabled
			/>
			<Input
				style={{ width: "48%" }}
				placeholder="Email"
				value={userDoc._.email}
				disabled
			/>
		</Row>

	);
};

export default CurrentUserField;
